
import { computed, defineComponent, toRef } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useCollection } from '../../composables'

export default defineComponent({
  name: 'CollectionPage',
  props: {
    name: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    onBeforeRouteUpdate(() => {
      // TODO Confirm leaving if changes in the form
    })
    onBeforeRouteLeave(() => {
      // TODO Confirm leaving if changes in the form
    })

    // TODO allow creating a new document
    const router = useRouter()
    const collectionName = toRef(props, 'name')
    const collection = useCollection(collectionName)
    const canEdit = computed<boolean>(
      () =>
        collection.value?.defaultView() !== 'card' &&
        !!collection.value?.canUpdate()
    )

    const store = useStore()
    const form = computed(() => store.getters['rxdb/form'])

    const read = () =>
      router.replace({
        name: 'collection',
        params: {
          name: props.name
        }
      })
    const edit = () =>
      router.replace({
        name: 'collection',
        params: {
          name: props.name,
          action: 'edit'
        }
      })
    const create = () =>
      router.push({
        name: 'newDocument',
        params: {
          collection: props.name
        }
      })
    const save = async () => {
      await store.dispatch('rxdb/save')
      read()
    }
    const reset = () => {
      store.commit('rxdb/reset')
    }
    const cancel = () => {
      reset()
      read()
    }
    return {
      form,
      collection,
      save,
      reset,
      cancel,
      canEdit,
      edit,
      create
    }
  }
})
